import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const forecastingAccuracyMerchantSchema = z.object({
  teamId: z.string(),
  name: z.string().nullable(),
  /** Distinct SKUs in ims_daily_order_volume for this team */
  skuCount: z.number(),
  /**
   * Weighted MAPE per horizon: sum(abs(forecast total - actual total)) /
   * sum(actual total) across the team's SKUs. Null while the horizon window
   * hasn't fully elapsed or the actual total is zero.
   */
  wmape14d: z.number().nullable(),
  wmape30d: z.number().nullable(),
  wmape60d: z.number().nullable(),
  wmape90d: z.number().nullable(),
  wmape120d: z.number().nullable(),
  /**
   * Fraction of sku-days in the horizon window excluded as stockouts:
   * sum(stockout days) / (horizon days * scored SKUs). Null while the window
   * hasn't fully elapsed.
   */
  stockoutRate14d: z.number().nullable(),
  stockoutRate30d: z.number().nullable(),
  stockoutRate60d: z.number().nullable(),
  stockoutRate90d: z.number().nullable(),
  stockoutRate120d: z.number().nullable(),
});

export type ForecastingAccuracyMerchant = z.infer<
  typeof forecastingAccuracyMerchantSchema
>;

export const getForecastingAccuracyDashboard = {
  name: "getForecastingAccuracyDashboard" as const,
  input: z.object({
    /**
     * Forecast run date to score. Null picks the most recent run at least 91
     * days old (so the 90d horizon is complete), falling back to the oldest
     * run when none is old enough.
     */
    originDate: zExt.plainDate().nullable(),
  }),
  output: z.object({
    /** The run actually scored; null when no forecast runs exist */
    originDate: zExt.plainDate().nullable(),
    availableOriginDates: z.array(zExt.plainDate()),
    merchants: z.array(forecastingAccuracyMerchantSchema),
  }),
};
